module.exports = __webpack_public_path__ + "static/media/tiet-ja-kadut.aaa24b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tiet-ja-kadut.jpg
// module id = 61
// module chunks = 0